// extracted by mini-css-extract-plugin
module.exports = {"Link":"LinkAction_Link__3uwDO","Orange":"LinkAction_Orange__8tqOm"};